import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Specifications = _resolveComponent("Specifications")
  const _component_LayerPopup = _resolveComponent("LayerPopup")
  const _component_router_view = _resolveComponent("router-view")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.isCookie)
      ? (_openBlock(), _createBlock(_component_LayerPopup, {
          key: 0,
          onOnClosed: _ctx.closedPopup
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Specifications)
          ]),
          _: 1
        }, 8, ["onOnClosed"]))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view)
  ], 64))
}